import React from "react";

import { Button } from "@mui/material";
import { getDomain, getProtocol } from "utils/auth";

const protocol = getProtocol();
const domain = getDomain();

export const JumpCloud: React.FC = () => {
  return (
    <Button
      href={`${protocol}${domain}/saml2/jump-cloud/login`}
      sx={{
        borderRadius: "5px",
        textTransform: "none"
      }}
      variant="contained"
    >
      SSO Login
    </Button>
  );
};
